// Third party
import 'bootstrap';
import '@babel/polyfill';

// First party
import './sass/style.scss';
import './js/helpers.js';
import './js/app.js';
import './js/slider.js';
import './js/animations';